import {
  CLIENT_MIX_RANGE,
  DAILY_INVOICING_RANGE,
  DAILY_LABOUR_RANGE,
  formatRangeDescription,
  OPENED_CASES_RANGE,
  TOP_CLIENTS_RANGE,
} from './defaultRanges';
import type { DashboardWidget } from '../types';

export const DEFAULT_WIDGETS: DashboardWidget[] = [
  {
    description: formatRangeDescription(DAILY_INVOICING_RANGE),
    id: 'daily-invoicing',
    title: 'Daily invoicing',
    type: 'dailyInvoicing',
  },
  {
    description: formatRangeDescription(OPENED_CASES_RANGE),
    id: 'opened-cases',
    title: 'Opened Cases',
    type: 'openedCases',
  },
  {
    description: formatRangeDescription(DAILY_LABOUR_RANGE),
    id: 'daily-labour',
    title: 'Daily labour',
    type: 'dailyLabour',
  },
  {
    description: formatRangeDescription(TOP_CLIENTS_RANGE),
    id: 'top-clients',
    title: 'Top Clients',
    type: 'topClients',
  },
  {
    description: formatRangeDescription(CLIENT_MIX_RANGE),
    id: 'client-mix',
    title: 'Client mix',
    type: 'clientMix',
  },
  {
    id: 'margins',
    title: 'Margins',
    type: 'margins',
  },
];
